import React from "react";
import { connect } from "react-redux";
import DynamicForm from "../../../components/dynamicscreens/DynamicForm";
import { EnquiryActionJson } from "../../../DynamicFormsJson/MastersJSON/enquiryAction";

class EnquiryActionForm extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <>
                <DynamicForm
                    formPath={EnquiryActionJson.formPath}
                    screenTitle={EnquiryActionJson.screenTitle}
                    fieldMeta={EnquiryActionJson.fieldMeta}
                    tableColumnsToFilter={EnquiryActionJson.tableColumnsToFilter}
                    apiBaseURL={EnquiryActionJson.apiBaseURL}
                    baseIdColumn={EnquiryActionJson.baseIdColumn}
                    type={0}
                    isLog={true}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(EnquiryActionForm);